import { useGlobalContext } from 'hooks/useGlobalContext';
import { useToastContext } from 'hooks/useToastContext';
import { useEffect, useState } from 'react';
import { SelectBox } from 'components/uikit-adapter/index'
import { default as Modal } from 'components/generic-modal';
import { formatErrorMessage } from '../../utils/handle-error'
import { StyledMultiSelect, Text, Title, Body, Footer } from './styled';
import Fetch from 'utils/fetch';
import IconStop from "components/icons/stop.icon";
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import Button from 'components/button';
import ButtonIcon from 'components/button-icon';

const ScheduleNotificationEmailSending = ({ isOpen, closeFn, initialSelectedSuppliers = [] }) => {
  const [emailSent, setEmailSent] = useState(false);
  const [selectedSuppliers, setSelectedSuppliers] = useState(initialSelectedSuppliers)
  const [suppliersForEmail, setSuppliersForEmail] = useState([])
  const { showFeedback } = useGlobalContext();  
  const { openToast } = useToastContext();
  
  const loadSuppliers = async () => {
    Fetch.get('usuario/buscaUsuariosFornecedor')
      .then((response) => { setSuppliersForEmail(response.data) })
  }

  const handleUpdateSelectedSuppliers = (value) => {
    setSelectedSuppliers(value)
  }

  const handleClose = () => {
    closeFn();
    setSelectedSuppliers([])
    setEmailSent(false);
  }

  const processError = (e) => {
    showFeedback(formatErrorMessage(e))
  }

  const scheduleEmailSending = async () => {
    const selectedSupplierIds = selectedSuppliers.map(x => x.Id);

    if (selectedSupplierIds.length === 0) {
      openToast(intl.get('ScheduleNotificationEmailSendingModal.supplierDropdownValidation'), 'negative');
    } else {
      return Fetch.post("notifications:manual-schedule-email", {
        SupplierUserIds: selectedSupplierIds,
      })
        .then(() => setEmailSent(true))
        .catch((e) => processError(e));
    }
  }

  const getModalContentForEmailNotSent = () => {
    return (
      <>
        <Body>
          <Text>{intl.get(`ScheduleNotificationEmailSendingModal.description`)}</Text>

          <StyledMultiSelect>
            <SelectBox
              name='supplier-select-box'
              value={selectedSuppliers}
              options={suppliersForEmail}
              valueKey='Id'
              labelKey='Nome'
              onChange={(values) => handleUpdateSelectedSuppliers(values)}
              searchable
              clearable
              openOnFocus
              multi
            />
          </StyledMultiSelect>
        </Body>
        <Footer>
          <ButtonIcon
            buttonType="tertiary"
            buttonText={intl.get('geral.buttonsDefault.cancel')}
            buttonIcon={<IconStop />}
            onClick={handleClose}
            style={{ width: '100px', height: '36px', border: 'none' }}
          />
          <Button
            buttonType="primary"
            value={intl.get('commons.confirm')}
            onClick={scheduleEmailSending}
            className="primary-btn-text"
            style={{ width: '115px', height: '36px' }}
          />
        </Footer>
      </>
    )
  }

  const getModalContentForEmailSent = () => {
    return (
      <>
        <Body>
          <Text>{intl.get(`ScheduleNotificationEmailSendingModal.successMessage`)}</Text>
        </Body>

        <Button
          buttonType="primary"
          value={intl.get('commons.ok').toUpperCase()}
          onClick={handleClose}
          style={{ width: '115px', height: '36px' }}
        />
      </>
    )
  }

  useEffect(() => {
    loadSuppliers();
  }, [])

  return (
    <Modal
      open={isOpen}
      onRequestClose={handleClose}
      modalStyle={{ maxWidth: '650px' }}
    >
      <Title>{intl.get(`ScheduleNotificationEmailSendingModal.title`)}</Title>
      {emailSent ? getModalContentForEmailSent() : getModalContentForEmailNotSent()}
    </Modal>
  )
}

ScheduleNotificationEmailSending.propTypes = {
  closeFn: PropTypes.func,
  isOpen: PropTypes.bool,
  initialSelectedSuppliers: PropTypes.array
}

export default ScheduleNotificationEmailSending;
